import CurrencyService from "../fx/CurrencyService.js";
import * as DomBuilder from "./dom-builder.js";

/**
 *
 * @version 2026-09-02
 * @author Patrik Harag
 */
export default class ComponentOptionsCurrency {

    /** @type {function()} */
    #refreshFunction;
    /** @type {HTMLElement} */
    #inputSelect;

    /**
     *
     * @param refreshFunction {function()}
     */
    constructor(refreshFunction) {
        this.#refreshFunction = refreshFunction;
    }

    createNode() {
        this.#inputSelect = DomBuilder.element('select', { class: 'btn btn-secondary' });
        for (let currency of CurrencyService.getSupportedCurrencies()) {
            let attrs = { value: currency };
            if (currency === CurrencyService.getDefaultCurrency()) {
                attrs.selected = true;
            }
            this.#inputSelect.append(DomBuilder.element('option', attrs, currency));
        }
        this.#inputSelect.addEventListener('change', () => {
            this.#refreshFunction();
        });
        return DomBuilder.div({ class: 'currency-component' }, this.#inputSelect);
    }

    getCurrency() {
        return this.#inputSelect.value;
    }
}
